import Protected from "@/pages/protected";
import { DashboardResultPage } from "@/pages/tools/dashboard/result";
import { Outlet, RouteObject } from "react-router-dom";

const DashboardRoute: RouteObject = {
    path: "dashboard",
    element: (
        <Protected groups={["app_tools_admin", "app_tools_dashboard_result"]}>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            path: "resultat/:site",
            element: <DashboardResultPage />
        }
    ]
};
export default DashboardRoute;
